import { render, staticRenderFns } from "./small-screen-profile-menu.vue?vue&type=template&id=470a7854&scoped=true"
import script from "./small-screen-profile-menu.vue?vue&type=script&lang=js"
export * from "./small-screen-profile-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470a7854",
  null
  
)

export default component.exports